<template>
    <div id="payment">
        <SfHeading
                :level="3"
                :title="$t('Payment')"
                class="sf-heading--left sf-heading--no-underline"
        />
        <transition mode="out-in" name="sf-fade">
            <div class="payment-methods">
                <!--<div class="giftCart">
                  <div class="coupon">
                    <div class="coupon-label">
        <span class="title">
                   <SfIcon :icon="icons.promo.path" :view-box="icons.promo.viewBox" color="white"
                           size="62px"></SfIcon>    <span class="text"> {{
            $t('You have a gift card ?')
          }}</span></span>

                    </div>
                    <div class="content">
                      <span class="desc">Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                      Quis ipsum suspendisse ultrices gravida.
                      Risus commodo viverra maecenas accumsan lacus vel facilisis. </span>
                      <div class="coupon-form">
                        <form class="form"

                          <SfInput v-model="giftCard" :placeholder="$t('Enter your code')"
                                   class="sf-input--coupon" type="text">
                          </SfInput>
                          <SfButton :disabled="!giftCard" class="sf-button--pure" type="submit">ok</SfButton>
                        </form>
                      </div>
                    </div>

                  </div>
                </div>-->
                <div :class="{ 'is-active': paymentMethod==='card'}" class="payment-method__card">

                    <SfRadio :selected="paymentMethod" label="" value="card"
                             @change="setPaymentMethod">
                        <template #label>
              <span class="label"><SfIcon :icon="icons.payment_card.path" :view-box="icons.payment_card.viewBox"
                                          color="#051039"
                                          size="42px"></SfIcon> <span class="text">{{ $t('card Payment') }} <cardPictos></cardPictos></span></span>
                        </template>
                    </SfRadio>
                    <div v-if="paymentMethod==='card'">
                        <transition>
                            <div class="content">
                                <div class="address">
                                    <SfHeading :level="3" :title="$t('Billing address')"></SfHeading>
                                    <div v-if="billingAddress">
                                        <div @click="changeBillingAddress">
                                            <UserAddress :address="billingAddress"
                                                         :show-address-name="false"

                                            ></UserAddress>
                                        </div>
                                        <SfButton class="sf-button--text color-tertiary" @click="changeBillingAddress">
                                            {{ $t('Change billing address') }}
                                        </SfButton>
                                        <SfButton class="sf-button--text color-tertiary" @click="toggleAddressModal">
                                            {{ $t('add new address') }}
                                        </SfButton>
                                    </div>
                                    <div v-else class="no-address">
                                        <p class="error">
                                            {{ $t('Add a billing address') }}.
                                            <SfButton v-if="customer.addresses.length>0"
                                                      class="sf-button--small color-tertiary"
                                                      @click="changeBillingAddress">
                                                {{ $t('Choose an address') }}
                                            </SfButton>
                                        </p>

                                        <SfButton class="sf-button--small" @click="toggleAddressModal"> {{
                                            $t('add new address')
                                            }}
                                        </SfButton>

                                    </div>

                                </div>
                                <div class="payment">
                                    <SfHeading :level="3" :title="$t('Card informations')"></SfHeading>

                                    <OrkAdyenPayment ref="OrkAdyenPayment" :currentCart="currentCart"
                                                     @handleResult="handleResult"
                                                     @paymentChange="paymentAction"/>
                                    <SfCheckbox v-model="terms" class="summary__terms" name="terms">
                                        <template #label>
                                            <div class="sf-checkbox__label">
                                                {{ $t('I agree to') }}
                                                <SfLink :link="$localizePath('/conditions-generales-de-vente')"
                                                        class="sf-button--text sf-button--underlined"
                                                        target="_blank"> {{
                                                    $t('Terms and conditions')
                                                    }}
                                                </SfLink>
                                            </div>
                                        </template>
                                    </SfCheckbox>
                                    <SfButton v-if="currentCart"
                                              :disabled=" !terms || !state.isValid || loading || !hasShipping || !hasBilling"
                                              class="sf-button color-secondary"
                                              type="button"
                                              @click="processOrder">
                     <span v-if="loading">
        <SfLoader :class="{ loader: loading }" :loading="loading"></SfLoader>
            {{ $t('Loading') }}
        </span>
                                        <span v-else>
                      {{ $t('Pay') }}
                      <span v-if="currentCart.specialPrice.taxIncluded">{{
                          $n(currentCart.specialPrice.taxIncluded, 'currency')
                          }}</span>
                      <span v-else>{{ $n(currentCart.totalPrice.taxIncluded, 'currency') }}</span>
                    </span>
                                    </SfButton>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <!--
                 <div :class="{
               'is-active': paymentMethod==='paypal'}" class="payment-method__paypal">
                   <SfRadio :selected="paymentMethod" label="Paypal" value="paypal" @change="setPaymentMethod">
                     <template #label>
                       <span class="label"><SfImage alt="Paypal" width="0 height="42px" src="/assets/images/cards/paypal.svg"
                       ></SfImage> <span class="text"></span> </span>
                     </template>
                   </SfRadio>
                 </div>
                 <div :class="{
               'is-active': paymentMethod==='flyinblue'}" class="payment-method__flyinblue">
                   <SfRadio :selected="paymentMethod" label="blue" value="flyinblue" @change="setPaymentMethod">
                     <template #label>
                       <span class="label"><SfImage alt="Flying Blue" height="42px" src="/assets/images/Flying_Blue_logo.png"
                                                    width="42px"></SfImage> <span class="text">{{
                           $t('Miles of my flying Blue account')
                         }}</span></span>
                     </template>
                   </SfRadio>
                 </div>
                 -->
                <div class="checkout actions">
                    <SfButton
                            :link="$localizePath('/commande/livraison')"
                            class='sf-button color-white'
                            type="button"
                    >
                        {{ $t('Previous step') }}
                    </SfButton>


                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import {
    SfHeading,
    SfCheckbox,
    SfButton,
    SfIcon,
    SfLink,
    SfLoader,
    SfRadio,
} from '@storefront-ui/vue';

import UserAddress from '@/components/UserAddress.vue';

import OrkAdyenPayment from '@/components/Checkout/AdyenPaymentProvider';
import CardPictos from '@/components/Checkout/CardPictos';
import Api from "@/api/Api";
import icons from "@/utils/icons";

export default {
    name: 'Payment',

    components: {
        CardPictos,
        UserAddress,
        SfLoader,
        SfRadio,
        SfHeading,
        SfCheckbox,
        SfButton,
        SfIcon,
        SfLink,
        OrkAdyenPayment,

    },
    data() {
        return {
            terms: false,
            paymentReady: false,
            giftCard: null,
            ip: null,
            icons: icons,
            loading: false,
            error: null,
            paymentMethod: 'card',
            state: {isValid: false},
            dropin: null,
            billingAddress: null,
            hasBilling: false,
            hasShipping: false
        };
    },
    computed: {
        customer: {
            get() {
                return this.$store.getters.getProfile;
            },
            set() {

            }
        },
        currentCart: {
            get() {
                return this.$store.getters.getCart;
            },
            set(cart) {
                return cart
            }
        }
    },
    watch: {
        currentCart: {
            handler(newCart) {
                if (newCart) {
                    this.getBillingAddress();
                    this.getShipment();
                }
            }, immediate: true
        },
        customer(newCustomer) {
            if (!newCustomer) {
                this.router.push('/');
            }
            if (newCustomer.defaultBillingAddress) {
                this.setBillingAddress(newCustomer.defaultBillingAddress)
            } else {
                this.getBillingAddress();
            }
        },
    },
    mounted() {

        this.getIP();
        this.getBillingAddress();
        // this.getShipment();
    },
    methods: {
        toggleAddressModal() {
            this.$store.dispatch("toggleAddressModal");
        },
        changeBillingAddress() {
            this.$store.dispatch('toggleAddressListModal');
        },
        setBillingAddress(address) {
            this.billingAddress = this.customer.addresses.find(address => address.name === this.customer.defaultBillingAddress) || address;
            Api.cart.setBillingAddress(this.billingAddress.name).then((data) => {
                this.$store.dispatch("setCart", data);
                this.currentCart = data;
                this.hasBilling = true;
            }).catch((e) => {
                let error = null;
                switch (e.status) {
                    case 401:
                        error = this.$i18n.t("errors.cartAdresse.unauthorized");
                        break;
                    case 409:
                        error = this.$i18n.t("errors.cartAdresse.allReadyExist");
                        break;
                    case 404:
                        error = this.$i18n.t("errors.cartAdresse.notFound");
                        break;
                    case 500:
                        error = this.$i18n.t("errors.server.access");
                        break;
                }
                if (error) {
                    this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
                }
                this.hasBilling = false;
            });

        },
        getBillingAddress() {
            if (!this.currentCart.billingAddress) {
                if (this.customer.defaultBillingAddress) {
                    this.billingAddress = this.customer.defaultBillingAddress
                    this.setBillingAddress(this.customer.defaultBillingAddress)
                }
            } else {
                this.billingAddress = this.currentCart.billingAddress
                this.hasBilling = true;
            }
        },

        getShipment() {
            if (!this.currentCart.shipments[0].address || !this.currentCart.shipments[0].shipmentMethod) {
                this.$router.push(this.$localizePath("/commande/livraison"));

            } else {
                this.hasShipping = true
            }
        },

        getIP() {
            this.ip = Api.payment.getIP();
        },
        handleResult(result) {

            this.loading = false
            if (result.resultCode.toLowerCase() === "authorised") {
                this.$router.push(this.$localizePath(`/commande/merci/${result.merchantReference}`)).catch(() => {
                    return null
                });
            } else if (result.resultCode.toLowerCase() === "updatecart") {
                Api.cart.getAnonymousCart(this.currentCart.id)
                    .then((cart) => {
                        this.$store.dispatch('setCart', cart);
                    }).catch((e) => {
                    this.$store.dispatch("sendNotification", {
                        type: "danger",
                        message: "errors.server.access",
                        icon: "error"
                    });
                });

                this.$store.dispatch("sendNotification", {
                    type: "danger",
                    message: "errors.payment.reload",
                    icon: "error"
                });

            } else if (result.error) {
                const error = result.error;
                if (error.status === 400) {
                    const offers = [];
                    const offersId = [];
                    offersId.push(error.message.split("'")[1]);

                    offersId.forEach((id) => {
                        this.currentCart.cartItems.map((item) => {
                            if (item.product.offer.id === id) {
                                offers.push(item);
                                item.noStock = true;
                            }
                        });
                    });
                    sessionStorage.setItem('NoStockItems', JSON.stringify(offersId));

                    if (offers.length > 0) {
                        this.$store.dispatch('toggleNoStockActionModal', {open: true, products: offers})
                    } else {
                        error.message = this.$i18n.t("errors.billing.address");
                    }
                    this.$store.dispatch("sendNotification", {type: "danger", message: error.message, icon: "error"});
                }
            } else {
                this.$router.push(this.$localizePath("/commande/paiement/resultat?data=" + encodeURIComponent(btoa(JSON.stringify(result)))));
            }
        },


        setGiftCard() {

        },
        setPaymentMethod(method) {
            this.paymentMethod = method
        },
        processOrder() {
            if (this.state && this.state.isValid && this.hasBilling && this.hasShipping) {
                this.loading = true;
                const state = this.state;
                const dropin = this.dropin;
                if (!window['disable-facebook']) {
                    fbq('track', "AddPaymentInfo");
                }
                this.$refs.OrkAdyenPayment.submitPayment({state, dropin}, this.currentCart);

            }
        },
        paymentAction(event) {
            this.state = event.state;
            this.dropin = event.dropin;
            if (event.state.isValid) {
                this.paymentReady = true;
            } else {
                this.paymentReady = false;
            }
        }
    }
}
;
</script>

<style lang="scss" scoped>
.coupon {
  display: flex;
  flex-wrap: wrap;
  background: var(--c-primary) url("/assets/images/fd_coupon.webp") no-repeat center;
  background-size: cover;
  color: var(--c-white);
  padding: var(--spacer-sm);
  border-radius: 4px;
  align-items: center;
  justify-content: space-between;
  margin: var(--spacer-lg) 0 var(--spacer-base);

  &-label {
    display: block;
    align-items: center;
    font-size: 1.875rem;
    font-weight: 700;
    //  text-transform: uppercase;
    width: 100%;

    .title {
      display: flex;
      width: 100%;

    }

    .text {

      align-items: center;
      width: 100%;
      display: flex;
      min-height: 42px;
      line-height: 42px;
      margin-left: var(--spacer-xs);
    }

    .desc {
      font-size: var(--font-size--base);
      font-weight: 400;
      text-transform: none;
      margin-left: var(--spacer-xs);
    }
  }

  .content {
    display: flex;

    > * {
      flex: 0 0 1;
    }

    .desc {
      width: 50%;
    }
  }

  &-form {
    flex: 1;
    position: relative;
    padding: 0;
    margin: 0;

    .sf-button {
      position: absolute;
      right: 0;
      top: 0;
      width: 42px;
      height: 42px;
      // text-transform: uppercase;
    }
  }

  ::v-deep {

    .sf-input {
      margin-bottom: 0;

      &__wrapper {
        margin: var(--input-margin, 0 0 0 0);
      }

      &__error-message {
        display: none;
      }

    }
  }
}

.payment-method__card {
  .content {
    display: flex;
    flex-wrap: wrap;
    align-self: stretch;
    gap: var(--spacer-base);

    .address, .payment {
      width: 50%;
      flex: 1;
      @include for-mobile {
        width: 100%;
        flex: none;
        flex-wrap: wrap;
      }

      .sf-heading {
        margin-bottom: var(--spacer-base);
      }


    }

    .address {
      margin: 0 0;

      position: relative;


      .user-address {
        border: none;
        margin-right: var(--spacer-base);
        margin-bottom: var(--spacer-sm);
        cursor: pointer;
      }


      &::after {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        display: block;
        content: '';
        width: 1px;
        background-color: var(--_c-lightgray);
        @include for-mobile {
          position: relative;
          width: 100%;
          height: 1px;
          margin: var(--spacer-base) 0;
        }
      }
    }

    .payment {
      .sf-button {
        @include for-mobile {
          width: 100%;
        }
      }

      .summary__terms {
        margin: var(--spacer-base) 0;

        .sf-link {
          font-size: var(--font-size--base);
        }
      }
    }
  }
}

.user-address {
  cursor: pointer;
}

div[class^='payment-method_'] {
  border: 1px solid var(--_c-primary-light);
  border-radius: 4px;
  padding: var(--spacer-base);
  @include for-mobile {
    padding: var(--spacer-sm);
  }
  margin: var(--spacer-base) 0;
  box-shadow: 0 2px 6px -2px rgb(0 0 0 / 10%);

  &:hover, &.is-active {
    box-shadow: 0 2px 6px -2px rgb(0 0 0 / 25%);
  }

  .sf-radio .label {
    display: flex;
    align-items: center;

    .text {
      flex: 1;
      flex-wrap: wrap;
      display: flex;
      align-items: center;
      margin-left: var(--spacer-xs);
      font-size: var(--font-size--lg);
      //text-transform: uppercase;
      font-weight: var(--font-weight--bold);

    }
  }
}

::v-deep {
  .sf-radio__container {
    display: flex;
    align-items: center;
  }
}

.sf-radio.is-active {
  background: none;
}

.checkout.actions {
  margin: auto 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  @include for-mobile {

  }

  .sf-button {
    width: fit-content;

    white-space: nowrap;
    min-height: 32px;
    padding: var(--spacer-sm) var(--spacer-sm);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      width: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: var(--spacer-sm) 0;
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}
</style>
